export default __webpack_public_path__ + "static/media/IMG_0040_5_11zon.589791c8.jpg";